window.ScrollStory = (function () {
  function init(sectionId) {
    var root = document.getElementById(sectionId);
    if (!root) return;

    var content = root.querySelector('[data-scroll-content]');
    var blocks = root.querySelectorAll('[data-scroll-block]');
    var images = root.querySelectorAll('[data-scroll-image]');

    if (!blocks.length || !content) return;

    var setActive = function (index) {
      images.forEach(function (img) {
        img.classList.toggle('is-active', img.getAttribute('data-scroll-image') === String(index));
      });
      blocks.forEach(function (block) {
        block.classList.toggle('is-active', block.getAttribute('data-scroll-block') === String(index));
      });
    };

    // Watch chapters INSIDE the scrollable text panel (root: content),
    // not the page/viewport — the page itself no longer scrolls for this.
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
            setActive(entry.target.getAttribute('data-scroll-block'));
          }
        });
      },
      {
        root: content,
        threshold: 0.6
      }
    );

    blocks.forEach(function (block) {
      observer.observe(block);
    });

    // Show the first chapter immediately, no scrolling required.
    setActive(0);

    // Theme editor convenience: clicking a block in the sidebar scrolls
    // the internal text panel to that chapter and activates it, so it's
    // never hidden while you're editing it.
    document.addEventListener('shopify:block:select', function (event) {
      var target = event.target.closest('[data-scroll-block]');
      if (target && root.contains(target)) {
        target.scrollIntoView({ block: 'nearest' });
        setActive(target.getAttribute('data-scroll-block'));
      }
    });
  }

  return { init: init };
})();